import React, { Suspense } from 'react';
import { useTypedSelector } from '@hooks';
import { useDebounced } from '@helpers/useDebounced';

const CompareVersionsModal = React.lazy(() => import('./CompareVersionsModal'));

export default function CompareVersionsModalContainer() {
  const modalState = useTypedSelector(
    ({ modal }) => modal.compareVersionsModal
  );
  const visibleDebounced = useDebounced(modalState?.visible, 300, false);
  const visible = modalState?.visible || visibleDebounced;
  if (!modalState || !visible) return null;
  return (
    <Suspense fallback={null}>
      <CompareVersionsModal
        isOpen={modalState?.visible || false}
        assetVersions={modalState?.assetVersions || []}
      />
    </Suspense>
  );
}
